module.exports = __webpack_public_path__ + "static/img/icon-text-action.3d7ff54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-text-action.svg
// module id = 157
// module chunks = 1